import { Device, type Device$options as DeviceType } from '$houdini';
import { isLargeDevice, isSmallDevice } from '$lib/utils/getPlatform';

export function getPartnersDeviceType(): DeviceType | undefined {
	if (typeof window === 'undefined') {
		return;
	}
	if (isSmallDevice()) {
		return Device.MOBILE;
	} else if (isLargeDevice()) {
		return Device.DESKTOP;
	}
	return Device.TABLET;
}
